export default {
  en: {
    contractList: 'Contract List',
    contract: 'Contract',
    newContract: 'New Contract',
    search: 'Search',
    reset: 'Reset',
    status: 'Status',
    all: 'All',
    refCode: 'Ref Code',
    code: 'Code',
    hotel: 'Hotel',
    agent: 'Agent',
    market: 'Market',
    salePerson: 'Sales Person',
    contractValid: 'Contract Valid',
    internalNote: 'Internal Note',
    updated: 'Updated',
    draft: 'Draft',
    published: 'Published',
    edit: 'Edit',
    preview: 'Preview',
    download: 'Download',
    email: 'Email',
    signedDocument: 'Signed Document',
    duplicate: 'Duplicate',
    delete: '*Delete',
    sendEmailContract: 'Send Email Contract',
    createContractSuccessTitle: 'Success',
    createContractSuccessMessage: 'Create Contract Success.',
    removeContractSuccess: 'Remove contract success',
    selectDate: 'Select Date',
    updateContractStatusSuccess: 'Update contract status success',
    confirmRemoveContractMessage: 'Confirm to remove contract {refCode}?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    popUpSelectDocumentType: 'Select Document Type'
  },
  th: {
    contractList: 'Contract List',
    contract: 'สัญญา',
    newContract: 'สัญญาใหม่',
    search: 'ค้นหา',
    reset: 'Reset',
    status: 'สถานะ',
    all: 'ทั้งหมด',
    refCode: 'รหัสอ้างอิง',
    code: 'รหัสอ้างอิง',
    hotel: 'โรงแรม',
    agent: 'ตัวแทน',
    market: 'ตลาด',
    salePerson: 'พนักงานขาย',
    contractValid: 'ระยะสัญญา',
    internalNote: 'โน๊ตภายใน',
    updated: 'แก้ไขล่าสุด',
    draft: 'ฉบับร่าง',
    published: 'เผยแพร่',
    edit: 'แก้ไข',
    preview: 'ดูตัวอย่าง',
    download: 'ดาวน์โหลด',
    email: 'ส่งเมล',
    signedDocument: 'เอกสารลงนาม',
    duplicate: 'คัดลอก',
    delete: '*ลบ',
    sendEmailContract: 'ส่งอีเมลสัญญา',
    createContractSuccessTitle: 'สำเร็จ',
    createContractSuccessMessage: 'สร้างสัญญาใหม่สำเร็จ',
    removeContractSuccess: 'ลบสัญญาสำเร็จ',
    selectDate: 'เลือกวันที่',
    updateContractStatusSuccess: 'แก้ไขสถานะสำเร็จ',
    confirmRemoveContractMessage: 'ยืนยันการลบสัญญาเลขที่ {refCode}?',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    popUpSelectDocumentType: 'เลือกชนิดเอกสาร'
  }
}
